import { createContext, useContext } from "react";

/**
 * Сайт открыт в WebView мобильного приложения: шапки и футера нет,
 * навигацию даёт приложение. Значение задаёт AppShell
 */
const AppModeContext = createContext(false);

export const AppModeProvider = AppModeContext.Provider;

export function useIsAppMode() {
  return useContext(AppModeContext);
}

/**
 * Высота шапки сайта на десктопе: под неё сдвигаются диалоги и боковые
 * панели. В приложении шапки нет
 */
export function useDesktopHeaderHeight() {
  return useIsAppMode() ? 0 : 64;
}
